import { combineReducers } from 'redux';

import fetchAllTripsReducerMap, {
    fetchAllTripsAction,
} from './actions/fetchAllTrips';
import fetchCachedTripsReducerMap, {
    fetchCachedTripsAction,
} from './actions/fetchCachedTrips';
import { serializeSearchParams } from './actions/utils';
import searchResultsReducerMap, {
    actions as searchResultsActions,
    selectors as searchResultsSelectors,
} from './appstate';
import namespace from './types';
import filterTrips, {
    filterNearby,
    filterTripsByRangeAndMode,
    filterTripsWithNearby,
    tripSatisfiesFilters,
} from './utils/filter';
import sortTrips from './utils/sort';

const reducer = combineReducers({
    ...fetchAllTripsReducerMap,
    ...fetchCachedTripsReducerMap,

    ...searchResultsReducerMap,
});

export {
    fetchAllTripsAction,
    fetchCachedTripsAction,

    filterNearby,
    filterTrips,
    filterTripsByRangeAndMode,
    filterTripsWithNearby,
    searchResultsActions,

    searchResultsSelectors,
    serializeSearchParams,
    sortTrips,

    tripSatisfiesFilters,
};

export default {
    [namespace]: reducer,
};
